import actionTypes from './actionTypes'

const immersiveReaderActions = {
	ivOeqTransform(activityUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_IMMERSIVE_READER_OEQ_TRANSFORM,
			activityUid,
		}
	},
	ivMcqTransform(activityUid) {
		return {
			type: actionTypes.INTERACTIVE_VIDEO_IMMERSIVE_READER_MCQ_TRANSFORM,
			activityUid,
		}
	},
	oeqTransform(slideId) {
		return {
			type: actionTypes.IMMERSIVE_READER_OEQ_TRANSFORM,
			slideId,
		}
	},
	drawItTransform(slideId) {
		return {
			type: actionTypes.IMMERSIVE_READER_DRAW_IT_TRANSFORM,
			slideId,
		}
	},
	pollTransform(slideId) {
		return {
			type: actionTypes.IMMERSIVE_READER_POLL_TRANSFORM,
			slideId,
		}
	},
	quizTransform(slideId) {
		return {
			type: actionTypes.IMMERSIVE_READER_QUIZ_TRANSFORM,
			slideId,
		}
	},
	matchingPairsTransform(slideId, text) {
		return {
			type: actionTypes.IMMERSIVE_READER_MATCHING_PAIRS_TRANSFORM,
			slideId,
			text,
		}
	},
	immersiveReaderTransformSuccess() {
		return {
			type: actionTypes.IMMERSIVE_READER_TRANSFORM_SUCCESS,
		}
	},
	immersiveReaderTransformError(error) {
		return {
			type: actionTypes.IMMERSIVE_READER_TRANSFORM_ERROR,
			error,
		}
	},
	readOnlyTransform(slideId, texts) {
		return {
			type: actionTypes.IMMERSIVE_READER_READ_ONLY_TRANSFORM,
			slideId,
			texts,
		}
	},
}

export default immersiveReaderActions
